import * as React from 'react';
import Stack from '@mui/material/Stack';
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {styled} from "@mui/material/styles";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Terms from "../Policy/Terms";
import Private from "../Policy/Private";
import UsePolicy from "../Policy/UsePolicy";
import Collect from '../Policy/Collect';
import Third from '../Policy/Third';
import Ads from '../Policy/Ads';

const JoinAgreePop = (props: any) => {
  type Anchor = 'bottom'
  const [state, setState] = React.useState({
    bottom: false,
  });

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };



  return (
    <React.Fragment>
      {(['bottom'] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <KeyboardArrowRightIcon sx={{ ml: 'auto', color: '#999' }} onClick={toggleDrawer(anchor, true)}/>
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            <Stack sx={{
              '& header' : {display:'none'},
              '& .contentStart' : {mt:0},
              '& .MuiBottomNavigation-root' : {display:'none'}
            }}> 
              <HighlightOffIcon sx={{ ml: 'auto', color: '#c10b0b', p:2, fontSize:30}} onClick={toggleDrawer(anchor, false)}/>
              {/* <Divider /> */}
              {props.type === 'terms' ? <Terms /> : props.type === 'private' ? <Private /> : props.type === 'collect' ? <Collect /> : props.type === 'third' ? <Third /> : props.type === 'ads' ? <Ads /> : <UsePolicy />}
              </Stack>
        
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </React.Fragment >
  );
}

export default JoinAgreePop;